import Vue from 'vue';
import VueRouter from 'vue-router';

export function useRouter () {
    Vue.use(VueRouter);
}
